import { createContext } from "react";
import { EPDStyle, light } from "../../core/styles";

type EPDStyleContextProps = {
  style: EPDStyle;
};

export const EPDStyleContext = createContext<EPDStyleContextProps>({
  style: light,
});
